import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from '@mui/material';

export const InfoIcon = styled(FontAwesomeIcon)(({ theme }) => ({
  color: theme.palette.colors.mainFocused,
  marginLeft: '5px',
}));
